export default __webpack_public_path__ + "static/media/Dusty@2x.e1f5d77a.jpg";